































import Vue from 'vue'
import Component from 'vue-class-component'
import player from './components/player.vue'
import headerNav from './components/header.vue'
import sidebar from './components/sidebar.vue'
import viewPlayer from './views/view.vue'

@Component({
  components: {
    player,
    headerNav,
    sidebar,
    viewPlayer
  }
})
export default class App extends Vue {
    get sideNav () {
        return this.$store.getters['getSideNav']
    }

    get current () {
        return this.$store.getters['getCurrent']
    }

    get showFull () {
        return this.$store.getters['getShowFull']
    }
}
